import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import { Spinner } from 'react-bootstrap';
import {toastr} from 'react-redux-toastr';

import { cronometro } from '../services/functions'
import { 
    verificaAgenteConectado, 
    listenerExtensionAvailable, 
    onSubmitLogin, 
    onSubmitStatus 
} from '../actions/AgentesActions';

class BoxConnectAgent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timer: '00:00:00',
            agente: {
                conectado: 0,
                c_agente_id: '',
                name: '',
                status: {},
                extension: {},
                queues: {}
            },
            queuesAvailable:[],
            statusAvailable: [],
            extensionAvailable: [],
            queuesListener: [],
            valuesSelectQueue: [],
            valuesSelectExtension: [],
            valuesSelectStatus: [],
            intevalID: 0,
            expired: 0,
            label: 'label label-success'
        };

        this.onChangeQueueSelect = this.onChangeQueueSelect.bind(this);
        this.onChangeExtensionSelect = this.onChangeExtensionSelect.bind(this);
        this.onChangeStatusSelect = this.onChangeStatusSelect.bind(this);
        this.handleSubmitLogin = this.handleSubmitLogin.bind(this);
        this.handleSubmitStatus = this.handleSubmitStatus.bind(this);
    }

    async componentDidMount() {
        let { queuesAvailable, statusAvailable, listQueues } = this.props.auth;
        let queuesListener = await _.map(queuesAvailable, queue => queue.extension)

        this.setState({ queuesAvailable, statusAvailable, queuesListener });

        const optionsQueues = this.state.queuesAvailable.map( queue => {
            return {
                 value: queue.extension, label: `[${queue.extension}] ${queue.name}`
            }
        })
        
        if( !listQueues ) { // Adiciona valores nos options da fila
            this.setState({ valuesSelectQueue: optionsQueues });
        }

        await this.props.verificaAgenteConectado(this.props.auth);
        await this.props.listenerExtensionAvailable(this.props.extensionAvailable);
        let intevalID = setInterval(this.passouSegundo, 300);
        this.setState({ intevalID });
    }

    _update = ({ agente, extensionAvailable }) => { 
        this.setState({ agente, extensionAvailable })
    }
 
    componentWillReceiveProps(nextProps) {
        this._update(nextProps);
    }
    
    passouSegundo = () => {
        let { agente } = this.state;
        let time = 0;
        let expired = 0;
        let label = 'label label-success';
        if(agente?.status?.iat){
            if(agente.status?.exp) {
                if(agente.status.c_pauses_id > 2) {
                    label = 'label label-warning';
                }

                if(agente.status.exp > agente.status.iat && new Date().getTime() > agente.status.exp) {
                    expired = 1;
                    label = 'label label-danger';
                }
            }

            time = cronometro(agente.status.iat, new Date().getTime());
        }
        this.setState({ timer: time, expired, label })
    }

    async handleSubmitLogin(event) {
        event.preventDefault();
        const { valuesSelectExtension, valuesSelectQueue } = this.state;
        const connectAgente = { extension: valuesSelectExtension, queues: valuesSelectQueue };
        if(Object.keys(valuesSelectExtension).length && valuesSelectQueue.length) {
            this.props.onSubmitLogin(connectAgente);
        } else {
            toastr.warning('Ops!', 'Por favor selecione um status !');
        }
    }

    handleSubmitStatus(event) {
        event.preventDefault();
        const { valuesSelectStatus } = this.state;
        if(Object.keys(valuesSelectStatus).length > 0) {
            this.props.onSubmitStatus(valuesSelectStatus);
        } else {
            toastr.warning('Ops!', 'Por favor selecione um status !');
        }
    }

    onChangeQueueSelect(value, event) {
        let valuesSelectQueue = value || [];
        this.setState({ valuesSelectQueue });
    }

    onChangeExtensionSelect(value, event) {
        this.setState({ valuesSelectExtension: value });
    }

    onChangeStatusSelect(value, event) {
        this.setState({ valuesSelectStatus: value });
    }

    componentWillUnmount() {
        clearInterval(this.state.intevalID);
    }

    render() {

        const optionsQueues = this.state.queuesAvailable.map( queue => {
            return {
                 value: queue.extension, label: `[${queue.extension}] ${queue.name}`
            }
        })

        const optionsExtensions = this.state.extensionAvailable.map( ext => {
            return {
                 value: ext.extension, label: `[${ext.extension}] ${ext.name}`
            }
        })

        if(this.state.agente?.conectado == 1) {
            const optionsStatus = this.state.statusAvailable.map( status => {
                return {
                     value: status.id, label: `${status.name}`
                }
            })

            let bloqueioPause = null;

            if(this.state.expired && this.props.auth.disable_pause){
                bloqueioPause = (
                    <h5>Você passou do limite da pausa, Favor solicitar ao supervisor a liberação</h5>
                )
            } else {
                bloqueioPause = (
                    <form onSubmit={this.handleSubmitStatus} >
                        <input type="hidden" name="action" value="actionAgente" />
                        <label className="control-label" htmlFor="inputError"> Alterar situação:</label>
                        <Select 
                                value={this.state.valuesSelectStatus}
                                options={optionsStatus} 
                                onChange={this.onChangeStatusSelect}
                            /> 
                        <div className="box-footer">
                            <button type="submit" className="btn btn-danger pull-right">Gravar</button>
                        </div>
                    </form>
                )
            }


            return (
                <div className="box box-danger box-solid" id="box_connect">
                    <div className="box-header">
                        <h3 className="box-title">Agente Conecta</h3>
                    </div>
                    <div className="box-body" id="connect">
                        <div className="box-body" id="connect">
                            <center>
                                <h3>
                                    <i className="icon fa fa-clock-o"></i> 
                                    <span id="cronometro">{this.state.timer}</span>
                                </h3>
                            </center>
                            <div className="row">
                                <div className="col-md-12">
                                <div className="box">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">
                                            <span className={this.state.label}>Situação: { this.state.agente.status?.name }</span>
                                        </h3>     
                                    </div>
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <p className="text-center">
                                                    <strong>Ramal</strong>
                                                </p>

                                                <div className="progress-group">
                                                    { this.state.agente.extension?.name }
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <p className="text-center">
                                                    <strong>Fila</strong>
                                                </p>
                                                { _.map( this.state.agente.queues, (val, extension) => (
                                                    <div className="progress-group" key={extension}>
                                                        {val.name}                             
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                            
                            <div className="form-group has-error">  
                                {bloqueioPause}
                            </div>
                        </div>
                    </div>
                </div>
                
            )
        } else if(this.state.agente?.conectado == 2) {
            return (
                <div className="box box-danger box-solid" id="box_connect">
                    <div className="box-header">
                        <h3 className="box-title">Aguardando atendimento</h3>
                    </div>
                    <div className="box-body" id="connect">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="box-body box-profile">
                                    <br/>        
                                    <p className="text-muted text-center">Seu aparelho irá tocar em breve por favor, atender para se conectar !</p>
                                    <br/>
                                    <h3 className="profile-username text-center">
                                        <Spinner  animation="grow" />
                                    </h3>
                                    <p className="text-muted text-center">Aguardando atendimento...</p>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else if(this.state.agente?.conectado == 3) {
            return (
                <div className="box box-danger box-solid" id="box_connect">
                    <div className="box-header">
                        <h3 className="box-title">Aguardando finalizar atendimento</h3>
                    </div>
                    <div className="box-body" id="connect">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="box-body box-profile">
                                    <br/>        
                                    <p className="text-muted text-center">Você desconectou do callcenter !</p>
                                    <br/>
                                    <h3 className="profile-username text-center">
                                        <Spinner  animation="grow" />
                                    </h3>
                                    <p className="text-muted text-center">Aguardando...</p>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

        const styles = {
            multiValue: (base, state) => {
              return true ? { ...base, backgroundColor: "gray" } : base;
            },
            multiValueLabel: (base, state) => {
              return true
                ? { ...base, fontWeight: "bold", color: "white", paddingRight: 6 }
                : base;
            },
            multiValueRemove: (base, state) => {
              return true ? { ...base, display: "none" } : base;
            }
        };

        return (
            <div className="box box-danger box-solid" id="box_connect">
                <div className="box-header">
                    <h3 className="box-title">Agente Conecta</h3>
                </div>
                <div className="box-body" id="connect">
                    <form onSubmit={this.handleSubmitLogin} >
                        <input type="hidden" name="action" value="logarAgent" />
                            
                        <label>Logar ramal na fila</label>
                        <div className="form-group">
                            <label>Ramal</label>
                            <Select
                                value={this.state.valuesSelectExtension}  
                                options={optionsExtensions} 
                                onChange={this.onChangeExtensionSelect}
                            />  
                        </div>

                        <div className="form-group">
                            <label>Fila</label>
                            <Select 
                                value={this.state.valuesSelectQueue}
                                options={optionsQueues} 
                                isMulti
                                onChange={this.onChangeQueueSelect}
                                styles={ this.props.auth.listQueues ? false : styles }
                                isClearable={false}
                            />  
                        </div>
                        
                        <div className="form-group">
                            <input type="submit" value="Logar" />
                        </div>
                    </form>
                </div>
            </div>
            
        );
    }
}

const mapStateToProps = state => {
    const extensionAvailable = _.map(state.AgentesReducer.extensionAvailable, (val, extension) => ({...val, extension}));
 
    return (
    {
        auth: state.AutenticacaoReducer,
        agente: state.AgentesReducer.agente,
        extensionAvailable,
    }
)}
  
export default connect(mapStateToProps, {
    verificaAgenteConectado, 
    listenerExtensionAvailable, 
    onSubmitLogin, 
    onSubmitStatus
})(BoxConnectAgent);